export const InputType = {
  PASSWORD: 'password',
  EMAIL: 'email',
  TEL: 'tel',
  COMBOBOX: 'combobox',
  CHECKBOX: 'checkbox',
  HIDDEN: 'hidden',
  TEXT: 'text',
  NUMBER: 'number',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  MULTICHECKBOX: 'multicheckbox',
  DATE: 'date',
  DATETIME: 'datetime',
  DATETIME_LOCAL: 'datetime-local',
  URL: 'url',
  FILE: 'file',
  DATERANGE: 'daterange',
  COMBOBOXMULTISELECT: 'comboboxmultiselect',
  RICHTEXT: 'richtext',
  RADIO: 'radio',
  IMAGEUPLOAD: 'imageupload',
  FIELDSET: 'fieldset',
  SORTABLELIST: 'sortablelist',
  SUBMIT: 'submit',
} as const;

// we accept strings because several unit tests still directly reference the string values of input types
export type InputType = (typeof InputType)[keyof typeof InputType] | string;
